import classNames from "classnames/bind";
import React from "react";
import MetricTile from "./MetricTile";
import styles from "./MetricTileGrid.module.scss";
import type { MetricTileGridProps } from "./types";

const cx = classNames.bind(styles);

/**
 * A grid layout container for Metric Tiles that can lay them out fluidly or evenly.
 */
const MetricTileGrid = ({
  data,
  layout = "masonry",
  isLoading,
  className,
  style,
}: MetricTileGridProps) => {
  return (
    <div
      className={cx("container", layout, className)}
      style={style}
    >
      {data.map(({ key, title, value, ...rest }, idx) => (
        <MetricTile
          key={key ? key : `${title}-${idx}`}
          title={title}
          value={value}
          {...(isLoading ? { isLoading } : {})}
          {...rest}
        />
      ))}
    </div>
  );
};

export default MetricTileGrid;
